import {Component, EventEmitter, Input, Output} from "@angular/core";
import {UtilsService} from "../../services/utils.service";

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  standalone: false
})

export class InputNumberComponent {
  @Input() value: any = 0;
  @Input() isValid: string = 'true';
  @Input() disabled: boolean = false;
  @Input() disableMinus: boolean = false;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<number>();

  constructor(private utils: UtilsService) {
  }

  minus() {
    if (!this.value) {
      this.value = 0;
    }
    this.value--;
    this.onChange();
  }

  // minus() {
  //   if (this.value > 0) {
  //     this.value--;
  //     this.onChange();
  //   }
  // }

  plus() {
    if (!this.value) {
      this.value = 0;
    }
    this.value++;
    this.onChange();
  }

  onChange() {
    this.change.emit(this.value);
  }

  onKeyDown(event: any) {
    if (event.code) {
      switch (event.code) {
        case 'Enter': {
          event.currentTarget.blur();
          break;
        }
        case 'Backspace':
        case 'Delete': {
          if (Number(this.value) < 10) {
            this.value = '';
          }
          break;
        }
      }
    } else {
      switch (event.keyCode) {
        case 13: {
          event.currentTarget.blur();
          break;
        }
        case 8:
        case 229: {
          if (Number(this.value) < 10) {
            this.value = '';
          }
          break;
        }
      }
    }
  }

  onFocus() {
    this.onChange();
  }

  onBlur() {
    if (!this.value) {
      this.value = 0;
      this.onChange();
    }
  }

  get isMinusDisabled(): boolean {
    return this.disabled || this.disableMinus;
  }

  onNoteFocus() {
    this.utils.scrollToFocusedElement();
  }
}
